import * as Yup from "yup";
import {
  twoDigitsFractionValidation,
  twoDigitsValidation,
} from "../utils/utils";

export const EditCountrySchema = Yup.object().shape({
  name: Yup.string()
    .trim("")
    .matches(/^[a-zA-Z ]*$/, "Country name must be alphabetical")
    .min(2, "Country must be at least 2 characters")
    .max(64, "Country must not be more than 64 characters")
    .required("Country is required"),
  country_code: Yup.string()
    .trim("")
    .matches(/^[a-zA-Z ]*$/, "Country name must be alphabetical")
    .min(2, "Country Code must be at least 2 characters")
    .max(2, "Country Code must not be more than 2 characters")
    .required("Country Code is required"),
  status: Yup.string().required("Status is required"),
});

export const AddCountrySchema = Yup.object().shape({
  name: Yup.string()
    .trim("")
    .matches(/^[a-zA-Z ]*$/, "Country name must be alphabetical")
    .min(2, "Country must be at least 2 characters")
    .max(64, "Country must not be more than 64 characters")
    .required("Country is required"),
  country_code: Yup.string()
    .trim("")
    .matches(/^[a-zA-Z ]*$/, "Country name must be alphabetical")
    .min(2, "Country Code must be at least 2 characters")
    .max(2, "Country Code must not be more than 2 characters")
    .required("Country Code is required"),
  status: Yup.string().required("Status is required"),
});

export const AddStateSchema = Yup.object().shape({
  state_name: Yup.string()
    .trim("")
    .matches(/^[a-zA-Z ]*$/, "State name must be alphabetical")
    .min(2, "State Name must be at least 2 characters")
    .max(132, "State Name must not be more than 132 characters")
    .required("State Name is required"),
  state_code: Yup.string()
    .trim("")
    .matches(/^[a-zA-Z]*$/, "State name must be alphabetical")
    .min(2, "State Code must be at least 2 characters")
    .max(2, "State Code must not be more than 2 characters")
    .required("State Code is required"),
  countryname: Yup.string()
    .trim("")
    .required("Country Name is required"),
  status: Yup.string().required("Status is required"),
});

export const EditStateSchema = Yup.object().shape({
  state_name: Yup.string()
    .trim("")
    .matches(/^[a-zA-Z ]*$/, "State Name must be alphabetical")
    .min(2, "State Name must be at least 2 characters")
    .max(132, "State Name must not be more than 132 characters")
    .required("State Name is required"),
  state_code: Yup.string()
    .trim("")
    .matches(/^[a-zA-Z]*$/, "State Code must be alphabetical")
    .min(2, "State Code must be at least 2 characters")
    .max(2, "State Code must not be more than 2 characters")
    .required("State Code is required"),
  countryname: Yup.string()
    .trim("")
    .required("Country Name is required"),
  status: Yup.string().required("Status is required"),
});

export const AddCitySchema = Yup.object().shape({
  name: Yup.string()
    .trim("")
    .required("Name is required"),
  state_name: Yup.string()
    .trim("")
    .required("State Name is required"),
  status: Yup.string().required("Status is required"),
});

export const EditCitySchema = Yup.object().shape({
  name: Yup.string()
    .trim("")
    .required("Name is required"),
  state_name: Yup.string()
    .trim("")
    .required("State Name is required"),
  status: Yup.string().required("Status is required"),
});

export const AddBankSchema = Yup.object().shape({
  bank_name: Yup.string()
    .trim("")
    .required("Bank Name is required"),
  status: Yup.string().required("Status is required"),
});

export const EditBankSchema = Yup.object().shape({
  bank_name: Yup.string()
    .trim("")
    .required("Bank Name is required"),
  status: Yup.string().required("Status is required"),
});

export const EditStatusUserSchema = Yup.object().shape({
  status: Yup.string().required("Status is required"),
});

export const CommissionSchema = Yup.object().shape({
  // achradio: Yup.string().required("required"),
  // wiretransferradio: Yup.string().required("required"),
  // echeckradio: Yup.string().required("required"),
  // creditcardradio: Yup.string().required("required"),
  // debitcardradio: Yup.string().required("required"),
  // wiretransferpercentage: Yup.number()
  //   .required("Commission Percentage is required")
  //   .min(0, `Commission Percentage should be greater than 0`)
  //   .test("is-decimal", "Commission Percentage is invalid", (value) =>
  //     (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
  //   ),
  // wiretransferfixedrate: Yup.number()
  //   .required("Commission Rate is required")
  //   .min(0, `Commission Rate should be greater than 0`)
  //   .test("is-decimal", "Commission Percentage is invalid", (value) =>
  //     (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
  //   ),
  echeckpercentageBusinessGeneral: Yup.number()
    .required("Commission Percentage is required")
    .min(0, `Commission Percentage should be greater than 0`)
    .test("is-decimal", "Commission Percentage is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
  echeckfixedrateBusinessGeneral: Yup.number()
    .required("Commission Rate is required")
    .min(0, `Commission Rate should be greater than 0`)
    .test("is-decimal", "Commission Rate is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
  // wiretransferpercentage: Yup.number()
  //   .required("Commission Percentage is required")
  //   .min(0, `Commission Percentage should be greater than 0`)
  //   .test("is-decimal", "Commission Percentage is invalid", (value) =>
  //     (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
  //   ),
  // wiretransferfixedrate: Yup.number()
  //   .required("Commission Rate is required")
  //   .min(0, `Commission Rate should be greater than 0`)
  //   .test("is-decimal", "Commission Percentage is invalid", (value) =>
  //     (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
  //   ),
  echeckpercentageUserGeneral: Yup.number()
    .required("Commission Percentage is required")
    .min(0, `Commission Percentage should be greater than 0`)
    .test("is-decimal", "Commission Percentage is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
  echeckfixedrateUserGeneral: Yup.number()
    .required("Commission Rate is required")
    .min(0, `Commission Rate should be greater than 0`)
    .test("is-decimal", "Commission Rate is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
  achpercentageUserGeneral: Yup.number()
    .required("Commission Percentage is required")
    .min(0, `Commission Percentage should be greater than 0`)
    .test("is-decimal", "Commission Percentage is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
  achfixedrateUserGeneral: Yup.number()
    .required("Commission Rate is required")
    .min(0, "Commission Rate should be greater than 0")
    .test("is-decimal", "Commission Rate is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
  achpercentageUserSC: Yup.number()
    .required("Commission Percentage is required")
    .min(0, `Commission Percentage should be greater than 0`)
    .test("is-decimal", "Commission Percentage is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
  achfixedrateUserSC: Yup.number()
    .required("Commission Rate is required")
    .min(0, "Commission Rate should be greater than 0")
    .test("is-decimal", "Commission Rate is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
  creditcardpercentageUserGeneral: Yup.number()
    .required("Commission Percentage is required")
    .min(0, `Commission Percentage should be greater than 0`)
    .test("is-decimal", "Commission Percentage is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
  creditcardfixedrateUserGeneral: Yup.number()
    .required("Commission Rate is required")
    .min(0, `Commission Rate should be greater than 0`)
    .test("is-decimal", "Commission Rate is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
  debitcardpercentageUserGeneral: Yup.number()
    .required("Commission Percentage is required")
    .min(0, `Commission Percentage should be greater than 0`)
    .test("is-decimal", "Commission Percentage is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
  debitcardfixedrateUserGeneral: Yup.number()
    .required("Commission Rate is required")
    .min(0, `Commission Rate should be greater than 0`)
    .test("is-decimal", "Commission Rate is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
  achpercentageBusinessGeneral: Yup.number()
    .required("Commission Percentage is required")
    .min(0, `Commission Percentage should be greater than 0`)
    .test("is-decimal", "Commission Percentage is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
  achfixedrateBusinessGeneral: Yup.number()
    .required("Commission Rate is required")
    .min(0, "Commission Rate should be greater than 0")
    .test("is-decimal", "Commission Rate is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
  achpercentageBusinessSC: Yup.number()
    .required("Commission Percentage is required")
    .min(0, `Commission Percentage should be greater than 0`)
    .test("is-decimal", "Commission Percentage is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
  achfixedrateBusinessSC: Yup.number()
    .required("Commission Rate is required")
    .min(0, "Commission Rate should be greater than 0")
    .test("is-decimal", "Commission Rate is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
  creditcardpercentageBusinessGeneral: Yup.number()
    .required("Commission Percentage is required")
    .min(0, `Commission Percentage should be greater than 0`)
    .test("is-decimal", "Commission Percentage is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
  creditcardfixedrateBusinessGeneral: Yup.number()
    .required("Commission Rate is required")
    .min(0, `Commission Rate should be greater than 0`)
    .test("is-decimal", "Commission Rate is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
  debitcardpercentageBusinessGeneral: Yup.number()
    .required("Commission Percentage is required")
    .min(0, `Commission Percentage should be greater than 0`)
    .test("is-decimal", "Commission Percentage is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
  debitcardfixedrateBusinessGeneral: Yup.number()
    .required("Commission Rate is required")
    .min(0, `Commission Rate should be greater than 0`)
    .test("is-decimal", "Commission Rate is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
  echeckpercentageUserSC: Yup.number()
    .required("Commission Percentage is required")
    .min(0, `Commission Percentage should be greater than 0`)
    .test("is-decimal", "Commission Percentage is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
  echeckfixedUserSC: Yup.number()
    .required("Commission Rate is required")
    .min(0, `Commission Rate should be greater than 0`)
    .test("is-decimal", "Commission Rate is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
  echeckpercentageBusinessSC: Yup.number()
    .required("Commission Percentage is required")
    .min(0, `Commission Percentage should be greater than 0`)
    .test("is-decimal", "Commission Percentage is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
  echeckfixedBusinessSC: Yup.number()
    .required("Commission Rate is required")
    .min(0, `Commission Rate should be greater than 0`)
    .test("is-decimal", "Commission Rate is invalid", (value) =>
      (value + "").match(/^(?!00)\d\d?(\.\d\d?)?$/)
    ),
});
